<!-- Bootstrap CSS -->
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
<!-- Bootstrap Icons -->
<link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css" rel="stylesheet">

<up-pin-entry *ngIf="currentState === 'PIN'"
              [costCentreId]="costCentreId"
              (pinValidated)="onPinValidated($event)">
</up-pin-entry>

<!-- =========================== -->
<!--    FLOAT DETAILS SCREEN     -->
<!-- =========================== -->
<div *ngIf="currentState === 'FLOAT_DETAILS'" class="container pt-5 min-vh-100 d-flex"
  style="max-width: 450px; position: relative;">

  <!-- Notification Toast for Float Details Screen -->
  <div *ngIf="showNotification" class="notification-toast" [class.notification-error]="notificationType === 'error'"
    [class.notification-warning]="notificationType === 'warning'"
    [class.notification-info]="notificationType === 'info'">
    <div class="notification-content">
      <div class="notification-icon">
        <i *ngIf="notificationType === 'error'" class="bi bi-exclamation-triangle-fill"></i>
        <i *ngIf="notificationType === 'warning'" class="bi bi-exclamation-circle-fill"></i>
        <i *ngIf="notificationType === 'info'" class="bi bi-info-circle-fill"></i>
      </div>
      <div class="notification-text">
        <div class="notification-title"><strong>{{ notificationTitle }}</strong></div>
        <div class="notification-message">{{ notificationMessage }}</div>
      </div>
      <button type="button" class="notification-close" (click)="hideNotification()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading; else contentLoaded" class="text-center p-5 d-block mx-auto">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden"></span>
    </div>
  </div>

  <!-- Main Content Template -->
  <ng-template #contentLoaded>
    <div class="content-wrapper">

      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="fw-bold text-dark mb-0">Confirm Cash Count</h2>
      </div>

      <p class="mb-4">
        Please confirm the end of shift cash amount handed over by {{ data?.employeeName }}.
      </p>

      <!-- Card Section -->
      <div class="card border-0 bg-light rounded-3 mb-4 mt-5">
        <div class="card-body pb-0">
          <div class="d-flex align-items-center mb-4 mt-n5">
            <div class="align-items-end justify-content-center me-3 overflow-hidden">
              <img [src]="data?.avatarUrl ?? '/assets/img/sales-person-image.png'" class="rounded-circle"
                style="max-width: 120px; max-height: 120px; object-fit: cover;" alt="Uploaded image" />
            </div>
            <div class="pt-3">
              <h5 class="fw-bold mb-0 text-dark">{{ data?.employeeName }}</h5>
              <div class="text-uppercase text-secondary small fw-semibold"
                style="font-size: 0.75rem; letter-spacing: 0.5px;">CASH DROP</div>
            </div>
          </div>

          <hr class="border-secondary my-3">

          <!-- Normal Flow Details -->
          <div *ngIf="!isIncorrectCountConfirmed" class="finance-details mt-3">
            <div class="d-flex justify-content-between align-items-center mt-1">
              <span class="fw-bold text-dark">Cash amount</span>
              <span class="fw-bold fs-5 text-dark">{{ data?.floatAmount | currency:'EUR':'symbol':'1.2-2' }}</span>
            </div>
          </div>

          <!-- Incorrect Count Details -->
          <div *ngIf="isIncorrectCountConfirmed" class="finance-details mt-3">
            <div class="d-flex justify-content-between mb-2">
              <span class="fw-bold text-dark">Cash Counted</span>
              <span class="fw-bold">{{ countedAmount | currency:'EUR':'symbol':'1.2-2' }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-dark">Cash Expected</span>
              <span class="fw-medium">{{ totalAmount | currency:'EUR':'symbol':'1.2-2' }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <span class="text-dark">{{ amountDifference > 0 ? 'Over' : 'Under' }}</span>
              <span class="fs-5"
                [ngClass]="{'text-danger': amountDifference !== 0, 'text-success': amountDifference === 0}">
                {{ amountDifference > 0 ? '+' : '' }}{{ amountDifference | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
            <div class="mt-4">
              <h6 class="fw-bold text-secondary mb-2">Comments</h6>
              <textarea class="form-control bg-white rounded-3 p-3 comment-textarea" [(ngModel)]="comment">
              </textarea>
            </div>
          </div>

          <div class="text-end mt-5 pt-3">
            <small class="text-secondary opacity-75">
              {{ data?.timestamp | date:'d MMMM y, h:mm' }}
            </small>
          </div>

        </div>
      </div>

      <!-- Action Button -->
      <!-- Confirm Button: Shows Counted Amount if incorrect count confirmed, else Total Amount -->
      <button (click)="openModal()" class="btn btn-primary w-100 py-3 rounded-3 fw-bold fs-5 custom-btn-blue">
        Confirm Count {{ (isIncorrectCountConfirmed ? countedAmount : totalAmount) | currency:'EUR':'symbol':'1.2-2' }}
      </button>

      <!-- Only show Count Incorrect if not already confirmed incorrect -->
      <button *ngIf="!isIncorrectCountConfirmed" (click)="countIncorrect()"
              class="btn btn-light w-100 py-3 rounded-3 fw-bold fs-5 mt-2 font-blue">
        Count Incorrect
      </button>
      <!-- Option to Edit count if needed -->
      <button *ngIf="isIncorrectCountConfirmed" (click)="countIncorrect()"
              class="btn btn-light w-100 py-3 rounded-3 fw-bold fs-5 mt-2 font-blue">
        Edit Count
      </button>

    </div>
  </ng-template>

  <!-- MODAL OVERLAY -->
  <div *ngIf="showModal" class="modal-backdrop fade show"></div>
  <!-- MODAL CONTENT -->
  <div *ngIf="showModal" class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered px-4">
      <div class="modal-content border-0 shadow-lg rounded-4 p-2">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title fw-bold">Confirm Cash Count</h5>
          <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body pt-3 pb-3">
          <p class="mb-5 fs-6">
            Are you sure you have received {{ (isIncorrectCountConfirmed ? countedAmount : totalAmount) |
            currency:'EUR':'symbol':'1.2-2' }}
            from {{ data?.employeeName }}?
          </p>
          <div class="d-flex gap-3">
            <button (click)="closeModal()" class="btn btn-primary w-100 py-2 rounded-3 fw-bold btn-modal-no">
              No
            </button>
            <button (click)="confirmHandover()" class="btn btn-primary w-100 py-2 rounded-3 fw-bold custom-btn-blue">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<up-count-incorrect *ngIf="currentState === 'COUNT_INCORRECT'"
                    [expectedAmount]="totalAmount"
                    [initialAmount]="countedAmount"
                    (confirmed)="onCountIncorrectConfirmed($event)"
                    (cancelled)="onCountIncorrectCancelled()">
</up-count-incorrect>

<!-- =========================== -->
<!--       QR CODE SCREEN        -->
<!-- =========================== -->
<div *ngIf="currentState === 'QR_CODE'" class="container mt-5 px-4" style="max-width: 450px;">

  <!-- 1. Header -->
  <h2 class="fw-bold mb-4 text-dark" style="letter-spacing: -0.5px;">Cash Count Confirmed</h2>

  <!-- 2. "Show this screen to:" -->
  <p class="text-dark mb-4">Show this screen to:</p>

  <!-- 3. Profile Section -->
  <div class="d-flex align-items-center mb-4">
    <div class="d-flex align-items-end justify-content-center me-3 overflow-hidden">
      <img [src]="data?.avatarUrl ?? '/assets/img/sales-person-image.png'" class="rounded-circle"
        style="max-width: 120px; max-height: 120px; object-fit: cover;" alt="Uploaded image" />
    </div>
    <div>
      <h5 class="fw-bold mb-0 text-dark">{{ data?.employeeName }}</h5>
      <div class="text-secondary">Waiter</div>
    </div>
  </div>

  <!-- 4. QR Card -->
  <div class="card border border-secondary border-opacity-25 rounded-4 p-2 mb-5">
    <div class="card-body d-flex justify-content-center align-items-center" style="min-height: 250px;">
      <qrcode [allowEmptyString]="true" [qrdata]="apronId" [width]="250">
      </qrcode>
    </div>
  </div>

  <!-- 5. Footer Text -->
  <div class="text-center">
    <h4 class="fw-bold text-dark">Counted {{ (countedAmount > 0 ? countedAmount : totalAmount) | currency:'EUR':'symbol':'1.2-2' }}</h4>
    <span *ngIf="isIncorrectCountConfirmed" class="fs-5 text-danger">
      {{ amountDifference > 0 ? 'Over +' : 'Under'}} {{ amountDifference | currency:'EUR':'symbol':'1.2-2' }}
    </span>
    <div class="text-muted text-left" *ngIf="comment">{{ comment }}</div>
  </div>
</div>

<!-- =========================== -->
<!--   HANDOVER COMPLETE SCREEN  -->
<!-- =========================== -->
<div *ngIf="currentState === 'HANDOVER_COMPLETE'"
     class="container min-vh-100 d-flex flex-column justify-content-center align-items-center text-center px-4">

  <!-- Green Checkmark -->
  <div class="mb-5">
    <div class="rounded-circle bg-success d-flex align-items-center justify-content-center"
         style="width: 120px; height: 120px;">
      <i class="bi bi-check-lg text-white" style="font-size: 5rem;"></i>
    </div>
  </div>

  <!-- Title -->
  <h2 class="fw-bold text-dark mb-4">
    Cash Drop Complete
  </h2>

  <!-- Message Content -->
  <div class="mt-2">
    <!-- CASE A: Correct Count (Not Confirmed Incorrect) -->
    <p *ngIf="!isIncorrectCountConfirmed" class="fs-5 text-dark" style="max-width: 350px;">
      You have successfully accepted
      <strong>{{ totalAmount | currency:'EUR':'symbol':'1.2-2' }}</strong>
      from {{ data?.employeeName }}
    </p>

    <!-- CASE B: Incorrect Count -->
    <div *ngIf="isIncorrectCountConfirmed">
      <p class="fs-5 text-dark mb-1">
        {{ data?.employeeName }}’s count: {{ totalAmount | currency:'EUR':'symbol':'1.2-2' }}
      </p>
      <p class="fs-5 text-danger fw-bold">
        Your cash count: {{ countedAmount | currency:'EUR':'symbol':'1.2-2' }}
      </p>
    </div>
  </div>

</div>